/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseManageTicketTags } from '../../models/api-response-manage-ticket-tags';

export interface GetTagsByRef$Params {
  ref: string;
}

export function getTagsByRef(http: HttpClient, rootUrl: string, params: GetTagsByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicketTags>> {
  const rb = new RequestBuilder(rootUrl, getTagsByRef.PATH, 'get');
  if (params) {
    rb.path('ref', params.ref, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseManageTicketTags>;
    })
  );
}

getTagsByRef.PATH = '/v1/api/ui/manage-ticket-tags/get/{ref}';
